export const limitedAvailability = {
  limitedAvailability: {
    partial: {
      title: 'Quantity Not Available',
      intro: 'The following item(s) have limited availability:',
      item: '{{sku}}: {{availableInventory}} units available',
      footer: 'Please reduce the requested quantities and try again.',
    },
    unavailable: {
      title: 'Product Unavailable',
      addIntro: 'The following product(s) are no longer in stock and will not be restocked:',
      updateIntro: 'The following item(s) are no longer in stock, will not be restocked, and were removed from your order:',
      addFooter: 'These items were not added to your cart.',
      contactFooter: 'Please consider alternative products or contact your sales representative with questions.',
    },
    cartUpdated: {
      title: 'Cart Updated',
      intro: 'One or more item quantities were adjusted based on current inventory availability. The following quantities were updated:',
      footer: 'Please review the updated quantities before continuing.',
    },
    checkoutModal: {
      title: 'Inventory Availability Updated',
      inventoryChangedIntro: 'The available inventory for one or more items has changed.',
      removedOnlyIntro: 'The following items are no longer available and will be removed from the order',
      removedIntro: 'The following items will be removed:',
      recommendedAlternatives: 'Recommended Alternatives:',
      adjustedIntro: 'The following quantities will be adjusted:',
      pleaseReviewChanges: 'Please review these changes before submitting your order.',
      quantityFooter: 'By selecting Continue and Place Order, you confirm that you accept the adjusted quantities.',
      removalFooter: 'By selecting Continue and Place Order, you confirm that you want to continue without these items.',
      mixedFooter: 'By selecting Continue and Place Order, you confirm that you accept these changes',
      reviewCart: 'Review Cart',
      continueAndPlaceOrder: 'Continue And Place Order',
    },
  },
};
